module.exports = __webpack_public_path__ + "img/add-widget.8538f685.gif";